<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字(名称、手机号码)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in MALL_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in MALL_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">商城数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="名称" align="center" prop="name"></el-table-column>
      <el-table-column label="手机号码" align="center" prop="phone"></el-table-column>
      <el-table-column label="国家名称" align="center" prop="countryName"></el-table-column>
      <el-table-column label="appSecurity" align="center" prop="appSecurity"></el-table-column>
      <el-table-column label="H5注册地址" align="center" prop="registH5"></el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ getValue(MALL_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="类型" align="center">
        <template slot-scope="scope">
          {{ getValue(MALL_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="expireTime" label="过期时间" width="160px">
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.expireTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="160px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="160px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button type="success" size="mini" @click="checkAppSignatureVisible(true, scope.row)"
            >获取APP签名</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="国家" prop="countryId">
          <el-select
            v-model="form.countryId"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in cascadeRegionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="商城名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="登录手机号码" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in MALL_TYPE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="H5注册地址" prop="registH5">
          <el-input v-model="form.registH5" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')">取消</el-button>
        <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!--    获取APP签名-->
    <el-dialog
      title="APP签名"
      :visible.sync="appSignatureVisible"
      :close-on-click-modal="false"
      width="50%"
      top="60px"
    >
      <div>
        {{ appSignatureData }}
        <span @click="copyClick(appSignatureData)" class="copy_key_pre">复制</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkAppSignatureVisible(false, {})">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editMall, getMallList, getAppSign } from "@/api/mall.js";
import { formatApiDate } from "@/utils/utils";
import { getCascadeRegion } from "@/api/common.js";
import { DIALOG_TITLE_TYPE, getValue, MALL_STATUS, MALL_TYPE } from "@/utils/enumUtile";
import { copyClick } from "@/utils/index.js";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    MALL_TYPE() {
      return MALL_TYPE;
    },
    MALL_STATUS() {
      return MALL_STATUS;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null,
        type: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        countryId: [{ required: true, message: "国家不能为空", trigger: "change" }],
        type: [{ required: true, message: "类型不能为空", trigger: "change" }],
        name: [{ required: true, message: "商城名称不能为空", trigger: "change" }],
        mobile: [{ required: true, message: "登录手机号码不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        countryId: null,
        type: null,
        name: null,
        mobile: null,
        registH5: null
      },
      btnLoading: false,
      appSignatureVisible: false, // 获取APP签名
      appSignatureData: null, // 签名
      cascadeRegionList: [] // 国家
    };
  },
  created() {
    this.getList();
    this.getCascadeRegion();
  },
  watch: {},
  methods: {
    getValue,
    copyClick,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询
     */
    getCascadeRegion() {
      const params = {
        parentId: 0
      };
      getCascadeRegion(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.cascadeRegionList = resp.data;
        }
      });
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getMallList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.countryId = editObj.countryId;
        this.form.type = editObj.type;
        this.form.name = editObj.name;
        this.form.mobile = editObj.phone;
        this.form.registH5 = editObj.registH5;
      }
      if (!status) {
        this.form.id = 0;
        this.form.countryId = null;
        this.form.type = null;
        this.form.name = null;
        this.form.mobile = null;
        this.form.registH5 = null;
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            countryId: form.countryId,
            type: form.type,
            name: form.name,
            mobile: form.mobile,
            registH5: form.registH5
          };
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editMall(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkDialogFormVisible(false);
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 获取app签名的弹框
     */
    checkAppSignatureVisible(status, item) {
      this.appSignatureVisible = status;
      if (status) {
        const params = {
          id: item.id
        };
        getAppSign(params).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.appSignatureData = resp.data;
          }
        });
      } else {
        this.appSignatureData = null;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
.copy_key_pre {
  background-color: #11b95c;
  border-radius: 4px;
  color: #ffffff;
  height: 26px;
  line-height: 26px;
  margin-left: 20px;
  cursor: pointer;
  padding: 4px 8px;
  width: 30px;
}
</style>
